import isEmpty from 'lodash/isEmpty';

export const setCookie = (key, value, options = {}) => {
  if (!isEmpty(key)) {
    const { path = '/', domain = '', days } = options;
    let cookieObj = {
      [key]: value,
      path,
    };

    // set domain to be available across subdomains
    if (!isEmpty(domain)) {
      cookieObj.domain = domain;
    }

    if (days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      cookieObj.expires = date.toGMTString();
    }

    const cookie = Object.keys(cookieObj).map(ckey => {
      return `${ckey}=${cookieObj[ckey]}`;
    });

    document.cookie = cookie.join(';');
  }
};

export const getCookie = name => {
  const cookieObj = document.cookie.split(';').reduce((res, c) => {
    const [key, val] = c
      .trim()
      .split('=')
      .map(decodeURIComponent);
    const allNumbers = str => /^\d+$/.test(str);
    try {
      return Object.assign(res, { [key]: allNumbers(val) ? val : JSON.parse(val) });
    } catch (e) {
      return Object.assign(res, { [key]: val });
    }
  }, {});

  return name in cookieObj ? cookieObj[name] : '';
};

export const deleteCookie = name => {
  if (!isEmpty(name)) {
    setCookie(name, '', { days: -1 });
  }
};
